import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import RegisterProvider from 'features/register/register-provider';
import { registerSteps } from '../register.constants';
import { useUserProfileQuery } from 'app/store';

const RegisterPage: React.FC = (): JSX.Element => {
    const navigate = useNavigate();
    const { data: profile } = useUserProfileQuery();

    useEffect(() => {
        if (profile?.status === 'accept') {
            navigate('/');
        }
    }, [profile?.status]);

    return <RegisterProvider steps={registerSteps} />;
};

export default RegisterPage;
